(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6389,6136,152],{

/***/ 22541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/whatsapp",
      function () {
        return __webpack_require__(94317);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 66136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SettingsConsumer": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "SettingsContext": function() { return /* binding */ SettingsContext; },
/* harmony export */   "SettingsProvider": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30152);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        ;
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 51514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66136);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__.SettingsContext);


/***/ }),

/***/ 59882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oS": function() { return /* binding */ formatDateToMonthShort; }
/* harmony export */ });
/* unused harmony exports formatDate, formatCreditCardNumber, formatExpirationDate, formatCVC */
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */ // ** Checks if the passed date is today
const isToday = (date)=>{
    const today = new Date();
    return new Date(date).getDate() === today.getDate() && new Date(date).getMonth() === today.getMonth() && new Date(date).getFullYear() === today.getFullYear();
};
const formatDate = function(value) {
    let formatting = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        month: "short",
        day: "numeric",
        year: "numeric"
    };
    if (!value) return value;
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ** Returns short month of passed date
const formatDateToMonthShort = function(value) {
    let toTimeForCurrentDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const date = new Date(value);
    let formatting = {
        month: "short",
        day: "numeric"
    };
    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {
            hour: "numeric",
            minute: "numeric"
        };
    }
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ? The following functions are taken from https://codesandbox.io/s/ovvwzkzry9?file=/utils.js for formatting credit card details
// Get only numbers from the input value
const clearNumber = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return value.replace(/\D+/g, "");
};
// Format credit cards according to their types
const formatCreditCardNumber = (value, Payment)=>{
    if (!value) {
        return value;
    }
    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;
    switch(issuer){
        case "amex":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 15));
            break;
        case "dinersclub":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 14));
            break;
        default:
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 8), " ").concat(clearValue.slice(8, 12), " ").concat(clearValue.slice(12, 19));
            break;
    }
    return nextValue.trim();
};
// Format expiration date in any credit card
const formatExpirationDate = (value)=>{
    const finalValue = value.replace(/^([1-9]\/|[2-9])$/g, "0$1/") // 3 > 03/
    .replace(/^(0[1-9]|1[0-2])$/g, "$1/") // 11 > 11/
    .replace(/^([0-1])([3-9])$/g, "0$1/$2") // 13 > 01/3
    .replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, "$1/$2") // 141 > 01/41
    .replace(/^([0]+)\/|[0]+$/g, "0") // 0/ > 0 and 00 > 0
    // To allow only digits and `/`
    .replace(/[^\d\/]|^[\/]*$/g, "").replace(/\/\//g, "/") // Prevent entering more than 1 `/`
    ;
    return finalValue;
};
// Format CVC in any credit card
const formatCVC = (value, cardNumber, Payment)=>{
    const clearValue = clearNumber(value);
    const issuer = Payment.fns.cardType(cardNumber);
    const maxLength = issuer === "amex" ? 4 : 3;
    return clearValue.slice(0, maxLength);
};


/***/ }),

/***/ 83552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
// ** Returns initials from string
const getInitials = (string)=>string.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "");


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 96665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);




const NoData = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [text, setText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [text2, setText2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [hrefText, setHrefText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const path = window.location.pathname;
        if (path.indexOf("android") != -1) {
            if (path.indexOf("android/local") != -1) {
                setText(t("If there is no data for only some of the features please go to the"));
                setText2(t("page to check Also the app cant track social media data before connection so please be patient if the app is fully authorized"));
                setHrefText(t("Permission check"));
                setHref("".concat("https://test-ms-dashboard.gbyte.com.cn", "/android/local/permission-check"));
                ;
            } else {
                setText(t("Please enable Google backup See"));
                setText2(t("for details"));
                setHrefText(t("here"));
            // if (locale && locale != 'en') {
            //   setHref(
            //     '/guide/back-up-android' + '-' + (locale == 'it-ch' ? 'it' : locale)
            //   )
            // } else {
            //   setHref('/guide/back-up-android')
            // }
            }
        } else {
            setText(t("Please enable iCloud backup See"));
            setText2(t("for details"));
            setHrefText(t("here"));
        // if (locale && locale != 'en') {
        //   setHref('/guide/back-up-ios' + '-' + (locale == 'it-ch' ? 'it' : locale))
        // } else {
        //   setHref('/guide/back-up-ios')
        // }
        }
    }, [
        locale,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "!h-[calc(var(--vh2)*100-240px)] smj:!h-[calc(var(--vh2)*100-115px)] w-full mt-5 [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-2",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 30152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ const themeConfig = {
    // ** Layout Configs
    templateName: "Msafely" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "light" /* light | dark | semi-dark /*! Note: semi-dark value will only work for Vertical Layout */ ,
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: false,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 300 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: false,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["default"] = (themeConfig);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 94317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ whatsapp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box_Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/android-whatsapp/index.js
var android_whatsapp = __webpack_require__(28837);
// EXTERNAL MODULE: ./src/@core/hooks/useSettings.js
var useSettings = __webpack_require__(51514);
// EXTERNAL MODULE: ./src/@core/utils/get-initials.js
var get_initials = __webpack_require__(83552);
// EXTERNAL MODULE: ./src/@core/utils/format.js
var format = __webpack_require__(59882);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(46483);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(51964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(57381);
// EXTERNAL MODULE: ./src/components/NoData/index.js
var NoData = __webpack_require__(96665);
;// CONCATENATED MODULE: ./src/@core/components/android/whatapp/whatapp-side-bar.js
// ** React Imports



// ** Next Import

// ** MUI Imports













// ** Third Party Components



// ** Icon Imports

// ** Custom Components Import




const callData = [
    {
        id: 1,
        name: "Harry",
        number: 6163566375
    }
];
const TextMessagesSideBar = (props)=>{
    const [scroll, setScroll] = (0,react.useState)(0);
    // 加载更多时的 loading 标记，供内层 ScrollWrapper 展示 Spin
    const [flag, setFlag] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (scroll >= 100) {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return;
            dispatch((0,android_whatsapp/* fetchUserProfile */.YI)());
            setFlag(true);
            setTimeout(()=>{
                setFlag(false);
            }, 1000);
        }
    }, [
        scroll
    ]);
    const ScrollWrapper = (param)=>{
        let { children , hidden  } = param;
        const store = (0,es/* useSelector */.v9)((state)=>state.androidWhatsapp);
        const dispatch = (0,es/* useDispatch */.I0)();
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    height: "100%",
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                    options: {
                        wheelPropagation: false
                    },
                    onScrollY: (e)=>{
                        setScroll((e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0));
                    },
                    children: [
                        children,
                        flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                        }) : null
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                options: {
                    wheelPropagation: false
                },
                onScrollY: (e)=>{
                    setScroll((e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0));
                },
                children: [
                    children,
                    flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                    }) : null
                ]
            });
        }
    };
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    // ** Props
    const { store , hidden , mdAbove , dispatch , selectMessage , sidebarWidth , leftSidebarOpen , handleLeftSidebarToggle , calls , setCalls , headImg , setHaedImg , setChat , setContacts , contacts  } = props;
    // ** States
    const [query, setQuery] = (0,react.useState)("");
    const [filteredChat, setFilteredChat] = (0,react.useState)([]);
    const [filteredContacts, setFilteredContacts] = (0,react.useState)([]);
    const [active, setActive] = (0,react.useState)(null);
    // ** Hooks
    const router = (0,next_router.useRouter)();
    const handleChatClick = (type, chatid, item)=>{
        setActive({
            type,
            chatid
        });
        if (JSON.parse(localStorage.getItem("androidWhatsappItem")).chatid == chatid) return;
        dispatch(selectMessage(item));
        localStorage.setItem("androidWhatsappItem", JSON.stringify(item));
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const hasActiveId = (chatid)=>{
        if (store.chats !== null) {
            const arr = store.chats.filter((i)=>i.chatid === chatid);
            return !!arr.length;
        }
    };
    const callHandler = ()=>{
        setChat(false);
        setContacts(false);
        setCalls(true);
    };
    const contactsHandler = ()=>{
        setChat(false);
        setCalls(false);
        setContacts(true);
    };
    const ChatHandler = ()=>{
        setChat(true);
        setCalls(false);
        setContacts(false);
    };
    const renderChats = ()=>{
        if (store && store.list && store.list.length) {
            let data = [];
            if (query.length > 0 && filteredChat.length > 0) {
                data = filteredChat;
            } else {
                data = store.list;
            }
            return data.map((item, index)=>{
                const activeCondition = active !== null && active.chatid === item.chatid && active.type === "messages";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    disablePadding: true,
                    sx: {
                        "&:not(:last-child)": {
                            mb: 1.5
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                        disableRipple: true,
                        onClick: ()=>handleChatClick("messages", item.chatid, item),
                        sx: {
                            px: 2.5,
                            py: 2.5,
                            width: "100%",
                            borderRadius: 1,
                            alignItems: "flex-start",
                            ...activeCondition && {
                                backgroundColor: (theme)=>"".concat(theme.palette.primary.main, " !important")
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                sx: {
                                    m: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    overlap: "circular",
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: item.avata != "" ? item.avata : item.defaultAvata,
                                        sx: {
                                            width: 40,
                                            height: 40,
                                            outline: (theme)=>"2px solid ".concat(activeCondition ? theme.palette.common.white : "transparent")
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                sx: {
                                    my: 0,
                                    ml: 4,
                                    mr: 1.5,
                                    "& .MuiTypography-root": {
                                        ...activeCondition && {
                                            color: "common.white"
                                        }
                                    }
                                },
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    noWrap: true,
                                    sx: {
                                        ...!activeCondition ? {
                                            color: "text.secondary"
                                        } : {}
                                    },
                                    children: item.subject
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    noWrap: true,
                                    variant: "body2",
                                    sx: {
                                        ...!activeCondition && {
                                            color: "text.disabled"
                                        }
                                    },
                                    children: item.snippet
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    justifyContent: "flex-start"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: {
                                        whiteSpace: "nowrap",
                                        color: activeCondition ? "common.white" : "text.disabled",
                                        fontSize: "13px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: item.time
                                    })
                                })
                            })
                        ]
                    })
                }, index);
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    sx: {
                        color: "text.secondary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
                })
            });
        }
    };
    const handleFilter = (e)=>{
        setQuery(e.target.value);
        if (store.list !== null && store.list.length > 0) {
            const filteredChatsArr = store.list.filter((item)=>{
                return item.chatid.indexOf(e.target.value) >= 0;
            });
            setFilteredChat(filteredChatsArr);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
            open: leftSidebarOpen,
            onClose: handleLeftSidebarToggle,
            variant: mdAbove ? "permanent" : "temporary",
            ModalProps: {
                disablePortal: true,
                keepMounted: false // Better open performance on mobile.
            },
            sx: {
                zIndex: 7,
                height: "100%",
                display: "block",
                position: mdAbove ? "static" : "absolute",
                "& .MuiDrawer-paper": {
                    boxShadow: "none",
                    overflow: "hidden",
                    width: sidebarWidth,
                    position: mdAbove ? "static" : "absolute"
                },
                "& > .MuiBackdrop-root": {
                    borderRadius: 1,
                    position: "absolute",
                    zIndex: (theme)=>theme.zIndex.drawer - 1
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    height: "calc(100% - 4.125rem)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                    hidden: hidden,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            p: (theme)=>theme.spacing(2, 3, 3)
                        },
                        children: [
                            !mdAbove ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                sx: {
                                    p: 1,
                                    ml: 1,
                                    mt: 4
                                },
                                onClick: handleLeftSidebarToggle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:close",
                                    fontSize: "1.375rem"
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                sx: {
                                    mb: 7.5,
                                    p: 0,
                                    mt: 4
                                },
                                className: "",
                                children: renderChats()
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var whatapp_side_bar = (TextMessagesSideBar);

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(28499);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(60770);
;// CONCATENATED MODULE: ./src/@core/components/android/whatapp/whatapp-log.js
// ** React Imports



// ** MUI Imports




// ** Third Party Components







const PerfectScrollbar = (0,styled/* default */.ZP)((lib_default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});
const AnyReactComponent = (param)=>/*#__PURE__*/ {
    let { text  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: " ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " absolute w-[180px] h-[40px] -mt-8 -ml-[70px] text-[13px] flex items-center text-center text-[#4d5976] text-opacity-90 font-[500] bg-white rounded-lg",
                    children: text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        icon: "material-symbols:location-on-rounded",
                        width: 50,
                        height: 50,
                        className: "text-[#FF5252]"
                    })
                })
            ]
        })
    });
};
const MessagesLog = (props)=>{
    // ** Props
    const { hidden  } = props;
    let data = (0,es/* useSelector */.v9)((state)=>state.androidWhatsapp.selectedMessage);
    const [flag, setFlag] = (0,react.useState)(false);
    // ** Ref
    const chatArea = (0,react.useRef)(null);
    // ** Scroll to chat bottom
    const scrollToBottom = ()=>{
        if (chatArea.current) {
            if (hidden) {
                // @ts-ignore
                chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER;
            } else {
                // @ts-ignore
                chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER;
            }
        }
    };
    // 记录首次加载
    const [isFirstLoad, setIsFirstLoad] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (data && data.chat && data.chat.length) {
            scrollToBottom();
            setIsFirstLoad(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    // ** Renders user chat
    const renderChats = ()=>{
        if (data.selected.length == 0) {
            if (data.contact.snippet == "") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        background: "#F5F5F5",
                        fontSize: "26px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#666",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        fontSize: "16px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "10px",
                        color: "#666",
                        height: "100%",
                        padding: "0 10px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            style: {
                                fontSize: "13px"
                            },
                            children: [
                                " ",
                                dayjs_min_default()(data.contact.snippetTimestamp).format("YYYY-MM-DD")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                data.contact.snippet
                            ]
                        })
                    ]
                });
            }
        }
        return data.selected.map((item, index)=>{
            const isSender = item.isFromMe;
            const time = item.time;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: !item.isFromMe ? "row" : "row-reverse"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    className: "chat-body",
                    sx: {
                        maxWidth: [
                            "calc(100% - 5.75rem)",
                            "75%",
                            "65%"
                        ],
                        minWidth: "74px",
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            "&:not(:last-of-type)": {
                                mb: 3.5
                            }
                        },
                        children: [
                            item.sender != "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: "#9ca3af",
                                    fontSize: "13px",
                                    position: "relative",
                                    bottom: "-8px"
                                },
                                children: item.sender
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        boxShadow: 1,
                                        borderRadius: 1,
                                        width: "fit-content",
                                        p: (theme)=>theme.spacing(0, 2),
                                        ml: isSender ? "auto" : undefined,
                                        borderTopLeftRadius: !isSender ? 0 : undefined,
                                        borderTopRightRadius: isSender ? 0 : undefined,
                                        color: isSender ? "black" : "text.primary",
                                        backgroundColor: isSender ? "#D1FAE5" : "#F3F4F6",
                                        mb: 4.4,
                                        mt: 2
                                    },
                                    children: (()=>{
                                        if (item.messageType === 0) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " flex p-2 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-semibold text-[0.8rem] text-black text-opacity-80 ",
                                                            style: {
                                                                display: "inline-block",
                                                                maxWidth: "400px",
                                                                overflow: "hidden"
                                                            },
                                                            children: item.text
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute bottom-0 right-0",
                                                        style: {
                                                            width: "120px",
                                                            left: !item.isFromMe ? "0" : "unset",
                                                            right: item.isFromMe ? "0" : "unset"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            variant: "caption",
                                                            sx: {
                                                                color: "text.disabled"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                children: time
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        } else if (item.messageType === 1 || item.messageType === 2) {
                                            let type = item.attachment.url;
                                            let tem = type.split(".");
                                            let suffix = tem.slice(tem.length - 1, tem.length).toString(String).split(".");
                                            suffix = suffix[0].toLowerCase();
                                            if (suffix === "jpg" || suffix === "png") {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " flex p-2 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-semibold text-[0.8rem] text-black text-opacity-80",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "https://cos.spyx.com/" + item.attachment.url,
                                                                    alt: "Picture of the author",
                                                                    width: 150,
                                                                    height: 150,
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: ()=>{
                                                                        dispatch((0,android_whatsapp/* setPerViewImage */.CJ)({
                                                                            open: true,
                                                                            url: "https://cos.spyx.com/".concat(item.attachment.url)
                                                                        }));
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute bottom-0 right-0 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                variant: "caption",
                                                                sx: {
                                                                    color: "text.disabled"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                    children: time
                                                                })
                                                            })
                                                        })
                                                    ]
                                                });
                                            } else if (suffix === "mp4" || suffix === "mov") {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " flex p-2 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-semibold text-[0.8rem] text-black text-opacity-80 ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                                                    controls: true,
                                                                    autoPlay: false,
                                                                    id: "video",
                                                                    preload: "none",
                                                                    loop: false,
                                                                    muted: false,
                                                                    children: [
                                                                        "can not be used Video",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                            src: "https://cos.spyx.com/" + item.attachment.url,
                                                                            type: "video/mp4"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                            src: "movie.ogg",
                                                                            type: "video/ogg"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute bottom-0 right-0 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                variant: "caption",
                                                                sx: {
                                                                    color: "text.disabled"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                    children: time
                                                                })
                                                            })
                                                        })
                                                    ]
                                                });
                                            } else if (suffix === "mp4" || suffix === "mov") {}
                                        } else if (item.messageType === 3) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("audio", {
                                                    controls: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            src: "https://cos.spyx.com/" + item.attachment.url,
                                                            type: "audio/mpeg"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("embed", {
                                                            height: "50",
                                                            width: "100",
                                                            src: "https://cos.spyx.com/" + item.attachment.url
                                                        })
                                                    ]
                                                })
                                            });
                                        } else if (item.messageType === 5) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    height: "300px",
                                                    width: "300px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
                                                    bootstrapURLKeys: {
                                                        key: "AIzaSyATBMz-vxnBoK1LIOxJYRRWjGbsA2VA0tY"
                                                    },
                                                    defaultCenter: {
                                                        lat: item.attachment.latitude,
                                                        lng: item.attachment.longitude
                                                    },
                                                    defaultZoom: 15,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnyReactComponent, {
                                                        lat: item.attachment.latitude,
                                                        lng: item.attachment.longitude,
                                                        text: item.attachment.vcardName
                                                    })
                                                })
                                            });
                                        } else if (item.messageType === 8) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " flex p-2 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-semibold text-[0.8rem] text-black text-opacity-80 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://cos.spyx.com/" + item.attachment.url,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                    icon: "mdi:file-word"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute bottom-0 right-0 ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            variant: "caption",
                                                            sx: {
                                                                color: "text.disabled"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                children: time
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        } else if (item.messageType === 15) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " flex p-2 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-semibold text-[0.8rem] text-black text-opacity-80",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "https://cos.spyx.com/" + item.attachment.url,
                                                                alt: "Picture of the author",
                                                                width: 150,
                                                                height: 150,
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>{
                                                                    dispatch((0,android_whatsapp/* setPerViewImage */.CJ)({
                                                                        open: true,
                                                                        url: "https://cos.spyx.com/".concat(item.attachment.url)
                                                                    }));
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute bottom-0 right-0 ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            variant: "caption",
                                                            sx: {
                                                                color: "text.disabled"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " text-[#9CA3AF] text-[0.6rem] ",
                                                                children: time
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    })()
                                })
                            })
                        ]
                    }, index)
                })
            }, index);
        });
    };
    const ScrollWrapper = (param)=>{
        let { children  } = param;
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PerfectScrollbar, {
                ref: chatArea,
                options: {
                    wheelPropagation: false
                },
                onYReachEnd: (container)=>{
                    if (store.selectedMessage.selected.length >= store.rightTotalCount) return;
                    dispatch((0,android_whatsapp/* selectMessage */.rT)());
                },
                children: [
                    children,
                    flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                    }) : null
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PerfectScrollbar, {
                ref: chatArea,
                options: {
                    wheelPropagation: false
                },
                onYReachEnd: (container)=>{
                    if (store.selectedMessage.selected.length >= store.rightTotalCount) return;
                    dispatch((0,android_whatsapp/* selectMessage */.rT)());
                },
                children: [
                    children,
                    flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                    }) : null
                ]
            });
        }
    };
    const store = (0,es/* useSelector */.v9)((state)=>state.WhatsApp);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [scroll, setScroll] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (scroll >= 100) {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return;
            dispatch((0,android_whatsapp/* selectMessage */.rT)());
            setFlag(true);
            setTimeout(()=>{
                setFlag(false);
            }, 1000);
        }
    }, [
        scroll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    height: "calc(100% - 60px)"
                },
                className: "bg-bgImg",
                children: hidden ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(PerfectScrollbar, {
                    ref: chatArea,
                    options: {
                        wheelPropagation: false
                    },
                    onScrollY: (e)=>{
                        const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0);
                        if (!isFirstLoad && progress >= 100) {
                            setScroll(progress);
                        }
                    },
                    children: [
                        renderChats(),
                        flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(PerfectScrollbar, {
                    ref: chatArea,
                    options: {
                        wheelPropagation: false
                    },
                    onScrollY: (e)=>{
                        const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0);
                        if (!isFirstLoad && progress >= 100) {
                            setScroll(progress);
                        }
                    },
                    children: [
                        renderChats(),
                        flag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                title: "",
                open: store.preViewImage.open,
                onCancel: ()=>{
                    dispatch((0,android_whatsapp/* setPerViewImage */.CJ)({
                        open: false,
                        url: ""
                    }));
                },
                width: "540px",
                footer: [],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        padding: "14px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: store.preViewImage.url,
                        width: 200,
                        height: 200,
                        style: {
                            width: "460px",
                            height: "auto"
                        },
                        alt: "preview"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var whatapp_log = (MessagesLog);

;// CONCATENATED MODULE: ./src/@core/components/android/whatapp/whatapp-content.js





// ** Icon Imports

// ** Custom Components Import


// ** Styled Components
const ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const TextMessagesContent = (props)=>{
    // ** Props
    const { data , store , hidden , mdAbove , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , headImg  } = props;
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            sx: {
                                fontWeight: 600
                            },
                            children: "Start Conversation"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#F9FAFB"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                py: 3,
                                px: 5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                backgroundColor: "#EFEFEF",
                                height: "60px"
                            },
                            className: "border-b-[1px] border-l-[1px] border-black border-opacity-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        mdAbove ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            onClick: handleLeftSidebarToggle,
                                            sx: {
                                                mr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                icon: "mdi:menu"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            onClick: handleUserProfileRightSidebarToggle,
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                className: "flex items-center ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-2 font-bold text-[15px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                            children: [
                                                                " ",
                                                                JSON.stringify(selectedMessage.contact) !== "{}" ? selectedMessage.contact.subject : ""
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "logos:whatsapp-icon",
                                        className: "w-[40px] h-[40px]"
                                    })
                                })
                            ]
                        }),
                        selectedMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(whatapp_log, {
                            hidden: hidden,
                            data: {
                                ...selectedMessage
                            }
                        }) : null
                    ]
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var whatapp_content = (TextMessagesContent);

;// CONCATENATED MODULE: ./src/@core/components/android/whatapp/whats-call.js





// ** Icon Imports


// ** Styled Components
const whats_call_ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const whats_call_TextMessagesContent = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , callData , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle  } = props;
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ _jsx(whats_call_ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ _jsx(Box, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            sx: {
                                fontWeight: 600
                            },
                            children: "Start Conversation"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs(Box, {
                        sx: {
                            flexGrow: 1,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                sx: {
                                    py: 3,
                                    px: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                    backgroundColor: "#EFEFEF",
                                    height: 60
                                },
                                className: "border-b-[1px] border-l-[1px] border-black border-opacity-10",
                                children: /*#__PURE__*/ _jsxs(Box, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        mdAbove ? null : /*#__PURE__*/ _jsx(IconButton, {
                                            onClick: handleLeftSidebarToggle,
                                            sx: {
                                                mr: 2
                                            },
                                            children: /*#__PURE__*/ _jsx(Icon, {
                                                icon: "mdi:menu"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            onClick: handleUserProfileRightSidebarToggle,
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Box, {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: " text-[#009788]",
                                                        children: /*#__PURE__*/ _jsx(Icon, {
                                                            icon: "fluent:call-24-filled",
                                                            width: 30,
                                                            height: 30
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "text-[17px] font-bold ml-2",
                                                        children: "Calls"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "overflow-auto h-[90%] bg-bgImg",
                                children: callData.calls.map((item)=>{
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "w-9/12 mx-auto flex justify-between items-center mt-6 border-b-[1px] border-[#f3f5f9] ",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center p-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "w-[40px] rounded-full",
                                                        children: /*#__PURE__*/ _jsx(Image, {
                                                            src: item.img,
                                                            alt: "img",
                                                            width: 100,
                                                            height: 40,
                                                            className: " rounded-full"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "ml-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                children: /*#__PURE__*/ _jsx("h2", {
                                                                    className: "text-[15px] text-[#53a2ec] font-semibold",
                                                                    children: item.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex mt-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        children: /*#__PURE__*/ _jsx(Icon, {
                                                                            icon: item.icon,
                                                                            className: "text-blue-500",
                                                                            width: 15,
                                                                            style: {
                                                                                color: item.state === -1 ? "red" : ""
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        children: /*#__PURE__*/ _jsx("h2", {
                                                                            className: "text-[12px] ml-2 text-[#4d5976] font-medium text-opacity-80",
                                                                            children: item.time
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("h2", {
                                                    className: "text-[13px] font-bold text-black text-opacity-60",
                                                    children: item.Time
                                                })
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        ]
                    })
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var whats_call = ((/* unused pure expression or super */ null && (whats_call_TextMessagesContent)));

;// CONCATENATED MODULE: ./src/@core/components/android/whatapp/whatsapp-contacts.js





// ** Icon Imports


// ** Styled Components
const whatsapp_contacts_ChatWrapperStartChat = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const WhatsappContacts = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , callData , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , setContacts  } = props;
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ _jsx(whatsapp_contacts_ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ _jsx(Box, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            sx: {
                                fontWeight: 600
                            },
                            children: "Start Conversation"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: "1232"
                        }),
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                flexGrow: 1,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "white"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    sx: {
                                        py: 3,
                                        px: 5,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                        backgroundColor: "#EFEFEF",
                                        height: 60
                                    },
                                    className: "border-b-[1px] border-l-[1px] border-black border-opacity-10",
                                    children: /*#__PURE__*/ _jsxs(Box, {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            mdAbove ? null : /*#__PURE__*/ _jsx(IconButton, {
                                                onClick: handleLeftSidebarToggle,
                                                sx: {
                                                    mr: 2
                                                },
                                                children: /*#__PURE__*/ _jsx(Icon, {
                                                    icon: "mdi:menu"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Box, {
                                                onClick: handleUserProfileRightSidebarToggle,
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "text-[#009788]",
                                                            children: /*#__PURE__*/ _jsx(Icon, {
                                                                icon: "mingcute:contacts-fill",
                                                                width: 30,
                                                                height: 30
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "text-[16px] font-bold ml-3",
                                                            children: "Contacts"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "overflow-auto h-[90%] bg-bgImg",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "grid grid-cols-4 gap-y-3 w-11/12 mx-auto mt-4 sm:grid-cols-2",
                                        children: callData.contacts.map((item)=>{
                                            return /*#__PURE__*/ _jsxs("div", {
                                                className: "bg-white rounded-lg h-[150px] w-5/6 items-center grid shadow-2xl",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "flex items-center justify-center",
                                                        children: /*#__PURE__*/ _jsx(Image, {
                                                            src: item.img,
                                                            alt: "img",
                                                            width: 55,
                                                            height: 55,
                                                            className: " rounded-full"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "flex items-center justify-center text-[14px]",
                                                        children: /*#__PURE__*/ _jsx("h2", {
                                                            className: "font-bold",
                                                            children: item.name
                                                        })
                                                    })
                                                ]
                                            }, item.id);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var whatsapp_contacts = ((/* unused pure expression or super */ null && (WhatsappContacts)));

// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.min.js
var ReactCrop_min = __webpack_require__(96120);
var ReactCrop_min_default = /*#__PURE__*/__webpack_require__.n(ReactCrop_min);
// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.css
var ReactCrop = __webpack_require__(96167);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(88484);
// EXTERNAL MODULE: ./node_modules/tesseract.js/src/index.js
var tesseract_js_src = __webpack_require__(7320);
var src_default = /*#__PURE__*/__webpack_require__.n(tesseract_js_src);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 28 modules
var upload = __webpack_require__(65170);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 10 modules
var es_button = __webpack_require__(75398);
;// CONCATENATED MODULE: ./src/@core/components/android/camera/tesseract.js








const ImageCropper = (param)=>{
    let { onTextChange  } = param;
    // 1. 创建状态
    const [src, setSrc] = (0,react.useState)(null);
    const [crop, setCrop] = (0,react.useState)({
        unit: "px",
        width: 100,
        height: 100
    });
    const [image, setImage] = (0,react.useState)(null);
    const [cutImage, setCutImage] = (0,react.useState)("");
    const [text, setText] = (0,react.useState)("");
    const canvasRef = (0,react.useRef)(null);
    const { t  } = (0,i18n/* useTranslation */.$G)("androidLogin");
    // 2. 处理图片上传
    const handleFileChange = (e)=>{
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = ()=>{
            setSrc(reader.result);
        };
        reader.readAsDataURL(file);
    };
    // 3. 读取并显示图片预览
    const handleImageLoaded = (image)=>{
        setImage(image);
    };
    // 4. 初始化裁剪组件
    const handleCropChange = (newCrop)=>{
        setCrop(newCrop);
    };
    // 5. 配置裁剪参数
    const handleCropComplete = (crop)=>{
        if (image && crop.width && crop.height) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            canvas.width = crop.width;
            canvas.height = crop.height;
            ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
            // 异步处理 OCR 识别
            setTimeout(()=>{
                const croppedImage = canvas.toDataURL("image/png");
                setCutImage(croppedImage);
                src_default().recognize(croppedImage, "eng", {
                    logger: (info)=>console.log(info)
                }).then((param)=>{
                    let { data: { text  }  } = param;
                    setText(text);
                    onTextChange(text);
                }).catch((err)=>{
                    ;
                });
            }, 100);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(upload/* default */.Z, {
                accept: "image/*",
                showUploadList: false,
                customRequest: (param)=>{
                    let { file  } = param;
                    // 处理文件上传
                    handleFileChange({
                        target: {
                            files: [
                                file
                            ]
                        }
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadOutlined/* default */.Z, {}),
                    children: t("Upload photo to identify number")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full justify-center items-center mt-2",
                children: src && /*#__PURE__*/ (0,jsx_runtime.jsx)((ReactCrop_min_default()), {
                    src: src,
                    crop: crop,
                    zoomable: true,
                    viewMode: 1,
                    onChange: handleCropChange,
                    onImageLoaded: handleImageLoaded,
                    onComplete: handleCropComplete
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    display: "none"
                }
            })
        ]
    });
};
/* harmony default export */ var tesseract = (ImageCropper);

// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 14 modules
var input = __webpack_require__(96456);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 26 modules
var tabs = __webpack_require__(75214);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MoreOutlined.js + 1 modules
var MoreOutlined = __webpack_require__(37446);
;// CONCATENATED MODULE: ./src/@core/components/android/encryption-key/index.js




const { TextArea  } = input/* default */.Z;





const { TabPane  } = tabs/* default */.Z;



const EncryptionKey = (param)=>{
    let {} = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("androidLogin");
    const [messageApi, contextHolder] = message/* default.useMessage */.ZP.useMessage();
    //识别出来的文字
    // const [recognizedText, setRecognizedText] = useState('')
    // 回调函数，用于接收子组件传来的 text
    const handleTextChange = (text)=>{
        setDigitKey(text);
    };
    // useEffect(() => {
    //   setDigitKey(recognizedText)
    // }, [recognizedText])
    let encryptionStatus = localStorage.getItem("encryption-key") === null ? true : false;
    try {
        if (!encryptionStatus) {
            encryptionStatus = JSON.parse(localStorage.getItem("userSummary"))[1].num === 0 ? true : false;
        }
    } catch (error) {}
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(encryptionStatus);
    const [phone, setPhone] = (0,react.useState)("");
    const [digitKey, setDigitKey] = (0,react.useState)("");
    const handleSubmit = async ()=>{
        const textWithoutSpaces = digitKey.replace(/\s/g, "") //格式化识别结果，去除空格
        ;
        if (phone == "") {
            (0,Message/* messageInfo */.B)(t("Please enter the whatsapp number"));
            return;
        }
        if ((textWithoutSpaces === null || textWithoutSpaces === void 0 ? void 0 : textWithoutSpaces.length) !== 64) {
            (0,Message/* messageInfo */.B)(t("Please enter the correct key"));
            return;
        }
        let username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        let result = await (0,dashboard/* androidWaKey */.gI)({
            googleAccount: username,
            waAccount: phone,
            encryptionKey: textWithoutSpaces
        });
        if (result.data.ec === 0) {
            (0,Message/* messageInfo */.B)(result.data.em);
            let download = await (0,login.gcloudDownload)({
                mode: 5,
                username: username
            });
            (0,Message/* messageInfo */.B)(download.data.ed);
            localStorage.setItem("encryption-key", true);
            setIsModalOpen(false);
        }
    };
    const [openBackup, setOpenBackup] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
            className: "equipment",
            open: isModalOpen,
            onCancel: ()=>setIsModalOpen(false),
            width: 700,
            closable: false,
            zIndex: 1000,
            footer: [],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        background: "#E7E7E7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                        borderTopRightRadius: "8px",
                        borderTopLeftRadius: "8px",
                        minHeight: "24px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            style: {
                                color: "#000000",
                                fontSize: "22px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            icon: "ic:round-cancel",
                            color: "#494949",
                            style: {
                                fontSize: "18px",
                                cursor: "pointer"
                            },
                            onClick: ()=>setIsModalOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        padding: "10px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        style: {
                            width: "100%",
                            background: "#fff"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        textAlign: "center",
                                        fontWeight: "700",
                                        color: "#000",
                                        fontSize: "16px"
                                    },
                                    children: t("Enter your 64-digit key")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "#696D6F",
                                        marginTop: "10px"
                                    },
                                    children: t("Enter WhatsApp number") + " (" + t("include the country code at the start") + ", e.g. " + t("US is") + "+1, " + t("UK is") + "+44). " + t("And paste the 64-digit key") + "."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    style: {
                                        color: "#3F87A5",
                                        textAlign: "center",
                                        marginTop: "10px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        fontWeight: 600
                                    },
                                    onClick: ()=>setOpenBackup(!openBackup),
                                    children: [
                                        t("Cant find the 64-digit key"),
                                        " "
                                    ]
                                }),
                                openBackup ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        marginBottom: "10px",
                                        marginTop: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step1"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreOutlined/* default */.Z, {
                                                            className: "text-[#000] text-[16px] font-[600]"
                                                        }),
                                                        "> ",
                                                        t("Settings"),
                                                        " > ",
                                                        t("Chats"),
                                                        " > ",
                                                        t("Chat backup"),
                                                        " >",
                                                        " ",
                                                        t("End-to-end encrypted backup"),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step2"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Tap"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-[600]",
                                                            children: [
                                                                " ",
                                                                t("TURN ON"),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step3"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Tap"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-[600]",
                                                            children: [
                                                                " ",
                                                                t("Use a 64-digit encryption key instead"),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step4"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Tap"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-[600]",
                                                            children: [
                                                                " ",
                                                                t("Generate your 64digit key"),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step5"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Press and hold 64-digit key click"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-[600]",
                                                            children: [
                                                                " ",
                                                                t("Copy"),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                marginTop: "14px",
                                                marginBottom: "10px"
                                            },
                                            children: [
                                                t("Then you can send the copy to your own phone or just take a picture and upload this one using the button below"),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step6"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Tap"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-[600]",
                                                            children: [
                                                                " ",
                                                                t("I Saved My 64digit key"),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step7"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Tap"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-[600]",
                                                            children: [
                                                                " ",
                                                                t("Create"),
                                                                " "
                                                            ]
                                                        }),
                                                        t("to complete"),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                display: "flex",
                                                marginTop: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: [
                                                        t("Step8"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        t("Paste the 64digit key below and click submit"),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    placeholder: t("WhatsApp Number"),
                                    style: {
                                        marginTop: "10px",
                                        borderRadius: "10px",
                                        padding: "0 10px",
                                        width: "100%",
                                        height: "40px",
                                        background: "#F7F8FA",
                                        outline: "none"
                                    },
                                    onChange: (e)=>{
                                        setPhone(e.target.value.trim());
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, {
                                    className: "digit_key",
                                    rows: 4,
                                    placeholder: t("64-digit key"),
                                    style: {
                                        marginTop: "10px",
                                        borderRadius: "10px",
                                        padding: "0 10px",
                                        width: "100%",
                                        background: "#F7F8FA",
                                        border: "0",
                                        height: "200px"
                                    },
                                    value: digitKey,
                                    onChange: (e)=>{
                                        setDigitKey(e.target.value.trim());
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        marginTop: "20px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        gap: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                            style: {
                                                background: "#3874EA",
                                                color: "#fff"
                                            },
                                            onClick: ()=>handleSubmit(),
                                            children: t("Continue")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tesseract, {
                                            onTextChange: handleTextChange
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var encryption_key = (EncryptionKey);

// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/hooks/useDeviceScopedInit.js
var useDeviceScopedInit = __webpack_require__(82017);
// EXTERNAL MODULE: ./src/components/ContentLoading/index.js
var ContentLoading = __webpack_require__(74743);
;// CONCATENATED MODULE: ./src/pages/android/whatsapp/index.js
// ** React Imports



// ** MUI Imports



// ** Store & Actions Imports


// ** Hooks

// ** Utils Imports


// ** Chat App Components Imports




// components




const WhatsApp = ()=>{
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    // ** States
    const [userStatus, setUserStatus] = (0,react.useState)("online");
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react.useState)(false);
    const [userProfileLeftOpen, setUserProfileLeftOpen] = (0,react.useState)(false);
    const [userProfileRightOpen, setUserProfileRightOpen] = (0,react.useState)(false);
    // ** Hooks
    const theme = (0,useTheme/* default */.Z)();
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const hidden = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const store = (0,es/* useSelector */.v9)((state)=>state.androidWhatsapp);
    const storeCommon = (0,es/* useSelector */.v9)((state)=>state.Common);
    // ** Vars
    const { skin  } = settings;
    const smAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const sidebarWidth = smAbove ? 370 : 300;
    const mdAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const [chat, setChat] = (0,react.useState)(true);
    const [calls, setCalls] = (0,react.useState)(false);
    const [headImg, setHaedImg] = (0,react.useState)("/images/whatsapp/1.jpg");
    const [contacts, setContacts] = (0,react.useState)(false);
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    // 设备切换时重置侧栏滚动并重拉 WhatsApp 摘要
    (0,useDeviceScopedInit/* useDeviceScopedInit */.A)((0,react.useCallback)(()=>{
        dispatch((0,android_whatsapp/* fetchUserProfile */.YI)());
    }, [
        dispatch
    ]));
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen((prev)=>!prev);
    const handleUserProfileLeftSidebarToggle = ()=>setUserProfileLeftOpen((prev)=>!prev);
    const handleUserProfileRightSidebarToggle = ()=>setUserProfileRightOpen((prev)=>!prev);
    (0,react.useEffect)(()=>{
        dispatch((0,Common/* setCurrentTab */.Lw)("Whatsapp"));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch
    ]);
    const fetchLoading = [
        true,
        "true"
    ].includes(store.fetchLoading);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative bg-[#009788] bg-[100px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute w-full h-[88%] bg-[#E0DEE1] mt-[150px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[94%] h-[96%] flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            className: "app-chat",
                            sx: {
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                borderRadius: 1,
                                position: "relative",
                                boxShadow: skin === "bordered" ? 0 : 6,
                                ...skin === "bordered" && {
                                    border: "1px solid ".concat(theme.palette.divider)
                                }
                            },
                            children: fetchLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(whatapp_side_bar, {
                                        store: store,
                                        hidden: hidden,
                                        mdAbove: mdAbove,
                                        dispatch: dispatch,
                                        userStatus: userStatus,
                                        selectMessage: android_whatsapp/* selectMessage */.rT,
                                        getInitials: get_initials/* getInitials */.Q,
                                        sidebarWidth: sidebarWidth,
                                        setUserStatus: setUserStatus,
                                        leftSidebarOpen: leftSidebarOpen,
                                        removeSelectedChat: android_whatsapp/* removeSelectedChat */.sr,
                                        userProfileLeftOpen: userProfileLeftOpen,
                                        formatDateToMonthShort: format/* formatDateToMonthShort */.oS,
                                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                                        handleUserProfileLeftSidebarToggle: handleUserProfileLeftSidebarToggle,
                                        calls: calls,
                                        setCalls: setCalls,
                                        chat: chat,
                                        contacts: contacts,
                                        headImg: headImg,
                                        setChat: setChat,
                                        setHaedImg: setHaedImg,
                                        setContacts: setContacts
                                    }),
                                    chat && /*#__PURE__*/ (0,jsx_runtime.jsx)(whatapp_content, {
                                        store: store,
                                        hidden: hidden,
                                        mdAbove: mdAbove,
                                        dispatch: dispatch,
                                        getInitials: get_initials/* getInitials */.Q,
                                        sidebarWidth: sidebarWidth,
                                        userProfileRightOpen: userProfileRightOpen,
                                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                                        headImg: headImg,
                                        setHaedImg: setHaedImg
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            Basic ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(encryption_key, {})
        ]
    });
};
WhatsApp.contentHeightFixed = true;
/* harmony default export */ var whatsapp = (WhatsApp);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,518,2862,770,2607,6664,210,8863,1964,6853,7891,1558,2586,6456,8499,2697,8791,5741,7206,9774,2888,179], function() { return __webpack_exec__(22541); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);